import { ReportDateFilter } from './common.types';
import { ReportDashboardComponentKind } from './consts.types';
import { ReportDashboardMetricOptions } from './metrics.types';
import {
  ReportsComponentTileFilterBreadcrumbSync,
  ReportsFilterBreadcrumb,
} from './report-component-filters-breadcrumbs.types';
import {
  ReportDashboardComponent,
  ReportDashboardComponentOptions,
  ReportDashboardComponentSettings,
  ReportParamFilters,
} from './report-component.types';
import { ReportResultsMeta } from './report-results.types';
import { Dimension, VisualizationDataTypeUnion } from './visualizations.types';

export interface BreadcrumbsData {
  kind: ReportDashboardComponentKind;
  filters: ReportParamFilters;
  metric: string;
  primaryGroup?: string | null;
  secondaryGroup?: string | null;
  dateFilter: ReportDateFilter;
  dateField: ReportDashboardComponent['dateField'];
  settings?: ReportDashboardComponentSettings;
  options?: ReportDashboardComponentOptions;
}

// filters on component only, before dashboard overrides
export type BaseComponentBreadcrumbsData = Pick<
  BreadcrumbsData,
  'filters' | 'dateFilter' | 'settings'
>;

export interface BreadcrumbsParams {
  data: BreadcrumbsData;
  metric: ReportDashboardMetricOptions;
  componentSavedFilters?: BaseComponentBreadcrumbsData;
}

export const BreadcrumbsServiceSymbol = Symbol('ComponentBreadcrumbsService');
export type BreadcrumbsServiceType = 'date' | 'applied' | 'datePoints';
export type AbsoluteDatesData =
  | {
      absoluteDates?: false;
    }
  | {
      absoluteDates: true;
      meta: ReportResultsMeta;
    };
export type BreadcrumbsBuilders = [
  BreadcrumbsService<'date', AbsoluteDatesData>,
  BreadcrumbsService<'datePoints'>,
  BreadcrumbsService<'applied'>,
];
export type ReportsBreadcrumbsDirector = {
  getBreadcrumbs: (
    data: BreadcrumbsData,
    metric: ReportDashboardMetricOptions,
    componentSavedFilters?: Pick<ReportDashboardComponent, 'filters' | 'dateFilter' | 'settings'>,
    visualizationData?: VisualizationDataTypeUnion,
  ) => ReportsFilterBreadcrumb[];
};

export interface BreadcrumbsService<
  T extends BreadcrumbsServiceType,
  AdditionalParams extends {} = {},
> {
  // Additional property to verify the type of the service, so that a list of all existing services can be provided
  readonly [BreadcrumbsServiceSymbol]: T;
  getBreadcrumbs: (params: BreadcrumbsParams & AdditionalParams) => ReportsFilterBreadcrumb[];
  getBreadcrumbsSync: (
    params: BreadcrumbsParams & AdditionalParams,
  ) => ReportsComponentTileFilterBreadcrumbSync[];
}

export interface DetailsBreadcrumbsParams {
  breadcrumbsSettings: BreadcrumbsData;
  dimensions: {
    primary: Dimension;
    secondary: Dimension[];
  };
}

export interface DetailsBreadcrumbsService {
  getBreadcrumbs: (params: DetailsBreadcrumbsParams) => ReportsFilterBreadcrumb[];
}
